var map = {
	"./carrefour": "hShW",
	"./carrefour.js": "hShW",
	"./casino": "OQHK",
	"./casino.js": "OQHK",
	"./default": "+2+B",
	"./default.js": "+2+B",
	"./num_commande": "Ahcr",
	"./num_commande.js": "Ahcr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Yobu";


//////////////////
// WEBPACK FOOTER
// ./src/processes/conf ^\.\/.*$
// module id = Yobu
// module chunks = 1